<template>
    <div >
      <div class="video">
        <video ref="video" playsinline autoplay></video>
        <div class="overlay overlay-top"></div>
        <div class="overlay overlay-bottom"></div>
        <div class="overlay overlay-left"></div>
        <div class="overlay overlay-right"></div>
      </div>
  
      <div class="video" style="z-index:23" v-if="selectedImage">
        <img :src="selectedImage"  style="width :auto;height :auto;max-width: 100%;max-height: 75%;"/>
      </div>
      <button v-if="selectedImage" class="button-send" style="z-index:50 !important;background-color: red;color:white" @click="selectedImage = null">Close Image</button>
      <button v-if="selectedImage" class="button-save" style="z-index:50 !important;" @click="saveImage()">Save Image</button>
      
      <!-- <div class="fullscreen">
      </div> -->
  
      <button class="button-zoom-in" @click="zoomIn">+</button>
      <button class="button-zoom-out" @click="zoomOut">-</button>
  
      <div class="small-square" ref="smallSqaure"></div>
      <button class="button-capture" @click="captureImage">Capture Image</button>
      <button class="button-clear" @click="clearImage">Clear Image</button>
      <button class="button-send" @click="sendImage">Send Image</button>
      <div class="image-container" v-if="capturedImages.length >= 1">
        <div class="image-scroll">
          <div class="image-wrapper">
            <div v-for="(image, index) in capturedImages" :key="index" class="image-item" :style="{ backgroundImage: 'url(' + image + ')' }" @click="showImage(image)"></div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  
  export default {
    data() {
      return {
        capturedImage: null,
        capturedImages: [],
        selectedImage : null,
        zoom : 1,

      }
    },
    mounted() {
      this.$nextTick(() => {
        this.startCamera();
      });
      // console.log('a')
      this.capturedImages = this.$store.getters.capturedImage
      console.log(this.capturedImages)
    },
    computed: {
        squareSize() {
            let height = window.innerHeight * (0.5)
            let width = window.innerWidth * 0.35
            return {height , width}
        },
    },
    methods: {
      zoomIn() {
        this.zoom += 0.15;
        this.$refs.video.style.transform = `scale(${this.zoom})`;
      },
      zoomOut() {
        if (this.zoom > 1) {
          this.zoom = Math.max(this.zoom - 0.15 , 1) ;
          this.$refs.video.style.transform = `scale(${this.zoom})`;
        }
      },
      showLoading (title, subTitle) {
        this.$swal.showLoading();
      },
      closeLoading () {
        this.$swal.hideLoading();
      },
      triggerSuccess(message){
        this.$swal.fire({
          title: "Success!",
          icon: 'success',
          text: message ? message : "What Message?"
        })
      },
      triggerError(message){
        this.$swal.fire({
          title: "Error!",
          icon: 'error',
          html: message ? message : "What Message?"
        })
      },
      async calculateScale(megapixels) {
        const reference1 = {
          megapixels: 12,
          scale: 2.64,
        };

        const reference2 = {
          megapixels: 7,
          scale: 1.54,
        };

        // Linear interpolation
        const t = (megapixels - reference2.megapixels) / (reference1.megapixels - reference2.megapixels);
        return (reference2.scale + t * (reference1.scale - reference2.scale)) * 10 + 1;
      },
      async startCamera() {
        

        navigator.mediaDevices.getUserMedia({
          video: { facingMode:  "environment" },
          audio: false
        }).then(stream => {
          
          this.$refs.video.srcObject = stream;

          
          this.$refs.video.play();

          this.$refs.video.addEventListener('loadedmetadata', async () => {
            const videoTrack = stream.getVideoTracks()[0];

            // Call getSettings() on the video track to get the actual resolution
            const settings = videoTrack.getSettings();
            const cameraWidth = settings.width;
            const cameraHeight = settings.height;
            const totalPixels = cameraWidth * cameraHeight;
            console.log(cameraHeight, cameraWidth)
            const megapixels = totalPixels / 1000000;
            console.log('%cManual.vue line:115 megapixels', 'color: #007acc;', megapixels);
            this.zoom = await this.calculateScale(megapixels);
            console.log('%cManual.vue line:116 this.zoom', 'color: #007acc;', this.zoom);
            this.$refs.video.style['transform-origin'] = 'center center';
            this.$refs.video.style['transform']='scale('+this.zoom+')';
          });
        })
        .catch(error => {
          console.log(error);
        });
      },
      stopVideo() {
        // this.$refs.video.pause();
        this.selectedImage = null;
      },
      showImage(image) {
        this.selectedImage = image;
        // this.$refs.video.pause();
      },
      clearImage () {
        this.$store.commit('clearCapturedImage')
        // this.capturedImages = this.$store.getters.capturedImage
        this.capturedImages = []
        // this.$set(this , 'capturedImages' , this.$store.getters.capturedImage)
      },
      async sendImage () {
        // alert('Image Send! API Not Available Yet')
  
        if (this.capturedImages.length == 0) {
          this.triggerError('No Image Captured');
          return;
        }

        let imageResult = []
  
        //Sending last image
        this.showLoading("Sending Image");
        try {
            for(var i = 0 ; i < this.capturedImages.length ; i++) {
                await axios.post('https://sweb-api.sequre.id/upload', {
                    imageb64str : this.capturedImages[i].slice(22, this.capturedImages[i].length-1)
                }, {
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                }
                })
                .then((resp)=>{
                //   this.triggerSuccess(`API Response: ${JSON.stringify(resp.data)}`);
                    imageResult.push(resp.data)    
                })

            }
        }
        catch(err) {
            console.log(err)
        }
        
        
        this.closeLoading();
        //Clear Image afterwards
        this.clearImage();
        this.$router.push({name : 'ResultPage' , query : {imageResult}})
      },
    captureImage() {
        const video = this.$refs.video;
        const videoWidth = video.videoWidth;
        const videoHeight = video.videoHeight;
        
        const scaleFactor = this.zoom;
        
        const canvas = document.createElement('canvas');
        canvas.width = this.squareSize.width;
        canvas.height = this.squareSize.height;
        let ctx = canvas.getContext('2d');

        const sourceX = (videoWidth - this.squareSize.width / scaleFactor) / 2;
        const sourceY = (videoHeight - this.squareSize.height / scaleFactor) / 2;

        ctx.drawImage(
            video,
            sourceX,
            sourceY,
            this.squareSize.width / scaleFactor,
            this.squareSize.height / scaleFactor,
            0,
            0,
            this.squareSize.width,
            this.squareSize.height
        );

        const capturedImage = canvas.toDataURL();
        this.capturedImage = capturedImage;

        this.$store.commit('setCapturedImage', capturedImage);
        this.capturedImages = this.$store.getters.capturedImage;
        },
        // captureImage() {
        //     const video = this.$refs.video;
        //     const videoWidth = video.videoWidth;
        //     const videoHeight = video.videoHeight;
            
        //     const scaleFactor = this.zoom;

        //     const canvas = document.createElement('canvas');
        //     canvas.width = this.squareSize.width;
        //     canvas.height = this.squareSize.height;
        //     let ctx = canvas.getContext('2d');

        //     ctx.drawImage(
        //         video,
        //         (videoWidth - this.squareSize.width * scaleFactor) / 2,
        //         (videoHeight - this.squareSize.height * scaleFactor) / 2,
        //         this.squareSize.width * scaleFactor,
        //         this.squareSize.height * scaleFactor,
        //         0,
        //         0,
        //         this.squareSize.width,
        //         this.squareSize.height
        //     );

        //     const capturedImage = canvas.toDataURL();
        //     this.capturedImage = capturedImage;

        //     this.$store.commit('setCapturedImage', capturedImage);
        //     this.capturedImages = this.$store.getters.capturedImage;
        // },
      saveImage () {
        console.log(this.selectedImage)
        var a = document.createElement("a"); //Create <a>
        a.href = this.selectedImage; //Image Base64 Goes here
        a.download = "Image.png"; //File name Here
        a.click(); //Downloaded file
      }
    }
  }
  </script>
  
  <style scoped>
  .image-container {
    position: fixed;
    bottom: 10px;
    left: 10px;
    right: 10px;
    z-index: 22;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba( 0,  0 , 0 ,0.3);
    padding-top: 10px;
    padding-bottom : 10px;
    width : 100% !important;
    overflow-x: scroll;
    overflow-y: hidden;
  }
  
  .image-scroll {
    max-height: 80px;
    
  }
  
  .image-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width : 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    
  }
  
  .image-item {
    width: 80px;
    height: 80px;
    margin-right: 10px;
    border-radius: 5px;
    /* background-size: cover; */
    background-position: center;
  }
  
  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
    cursor: pointer;
  }
  
  .video {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    
  }
  
  /* video {
    
    z-index : 0;
    height: 100%;
    width : 100%
  } */
  
  .overlay {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.7);
    pointer-events: none;
    z-index: 1;
  }
  .overlay-top {
    top: 0;
  }
  
  .overlay-bottom {
    bottom: 0;
  }
  
  .overlay-top,
  .overlay-bottom {
    left: 0;
    right: 0;
    height: calc(50% - 100px);
  }
  
  .overlay-left,
  .overlay-right {
    top: calc(50% - 100px);
    bottom: calc(50% - 100px);
    width: calc(50% - 70px);
  }
  
  .overlay-left {
    left: 0;
  }
  
  .overlay-right {
    right: 0;
  }
  
  .small-square {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 35%;
    height: 50%;
    max-width: 200px;
    max-height: 200px;
    transform: translate(-50%, -50%);
    outline: 2px solid white;
    z-index: 2;
  }
  
  
  
  video {
    z-index: 0;
    height: 100%;
    width: 100%;
    /* object-fit: cover; */
  }
  
  .button-capture {
    position: fixed;
    bottom: 7em; /* 20px / 16px = 1.25em */
    right: 1.25em; /* 20px / 16px = 1.25em */
    margin: 0.625em; /* 10px / 16px = 0.625em */
    background-color: #fff;
    border: 1px solid #000;
    border-radius: 5px;
    padding: 0.625em 1em; /* 10px / 16px = 0.625em, 16px = 1em */
    font-size: 1em; /* 16px = 1em */
    cursor: pointer;
    z-index : 22;
  }
  
  .button-clear {
    position: fixed;
    bottom: 7em; /* 20px / 16px = 1.25em */
    left: 1.25em; /* 20px / 16px = 1.25em */
    margin: 0.625em; /* 10px / 16px = 0.625em */
    background-color: #fff;
    border: 1px solid #000;
    border-radius: 5px;
    padding: 0.625em 1em; /* 10px / 16px = 0.625em, 16px = 1em */
    font-size: 1em; /* 16px = 1em */
    cursor: pointer;
    z-index : 22;
  }
  
  .button-send {
    position: fixed;
    top: 1em; /* 20px / 16px = 1.25em */
    left: 1.25em; /* 20px / 16px = 1.25em */
    margin: 0.625em; /* 10px / 16px = 0.625em */
    background-color: #fff;
    border: 1px solid #000;
    border-radius: 5px;
    padding: 0.625em 1em; /* 10px / 16px = 0.625em, 16px = 1em */
    font-size: 1em; /* 16px = 1em */
    cursor: pointer;
    z-index : 22;
  }
  
  .button-save {
    position: fixed;
    top: 1em; /* 20px / 16px = 1.25em */
    right: 1.25em; /* 20px / 16px = 1.25em */
    margin: 0.625em; /* 10px / 16px = 0.625em */
    background-color: green;
    border: 1px solid #000;
    border-radius: 5px;
    color : white;
    padding: 0.625em 1em; /* 10px / 16px = 0.625em, 16px = 1em */
    font-size: 1em; /* 16px = 1em */
    cursor: pointer;
    z-index : 22;
  }
  
  
  .fullscreen {
    position: fixed;
    top : 0;
    left : 0;
    right : 0;
    bottom : 0;
    width: 100%;
    height :100%;
    background-color : rgba(0,0,0,0.4);
    /* z-index : 20; */
  }
  
  .small-square {
    position: absolute;
    top : 50%;
    left : 50%;
    width: 35%;
    height :50%;
    max-width: 200px;
    max-height: 200px;
    background-color : transparent;
    transform : translate(-50% , -50%);
    border : 2px solid white;
  
    z-index : 21;
  }
  
  .button-zoom-in {
    position: fixed;
    top: 1em;
    right: 1.25em;
    margin: 0.625em;
    background-color: #fff;
    border: 1px solid #000;
    border-radius: 5px;
    padding: 0.625em 1em;
    font-size: 1em;
    cursor: pointer;
    z-index: 22;
    width : 40px;
    text-align: center;
  }
  
  .button-zoom-out {
    position: fixed;
    text-align: center;
    top: 4.5em;
    right: 1.25em;
    margin: 0.625em;
    background-color: #fff;
    border: 1px solid #000;
    border-radius: 5px;
    padding: 0.625em 1em;
    width : 40px;
    font-size: 1em;
    cursor: pointer;
    z-index: 22;
  }
  
  </style>
  